import axios, { AxiosInstance } from 'axios';
import type { LocaleResponse } from '../types/textCms';

const explicitApiUrl = process.env.REACT_APP_TEXT_CMS_API_URL;

const isProduction = process.env.NODE_ENV === 'production';
const isTestEnv = process.env.REACT_APP_IS_TEST_ENV === 'true';
const isTestFromBackendUrl = process.env.REACT_APP_URL_BACKEND_API?.includes('test.medbioinformatics.com');

let API_URL: string;

if (explicitApiUrl) {
  API_URL = explicitApiUrl;
} else if (isProduction && !isTestEnv && !isTestFromBackendUrl) {
  // Producción
  API_URL = process.env.REACT_APP_TEXT_CMS_API_URL_PROD || 'https://ej6r7qkjyd.execute-api.eu-central-1.amazonaws.com';
} else {
  // Test
  API_URL = process.env.REACT_APP_TEXT_CMS_API_URL_TEST || 'https://ab3lgjqe87.execute-api.eu-central-1.amazonaws.com';
}

class TextCmsService {
  private apiClient: AxiosInstance;

  constructor() {
    this.apiClient = axios.create({
      baseURL: API_URL,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  async getTexts(locale: string = 'en'): Promise<LocaleResponse> {
    const response = await this.apiClient.get<LocaleResponse>(`/texts/${locale}`);
    return response.data;
  }
}

export const textCmsService = new TextCmsService();

export default textCmsService;
